import { Templates } from '../../compile';
import { SelectableOptions } from '../../interfaces/options';

export const DefaultSelectableOptions: SelectableOptions = {
	id: undefined,
	template: Templates.general_empty,
	isSelected: false
};
